const localization = {
    general: {
        component_barcode: 'Component Barcode Value',
        daily_fluid_milk_quota: 'Quota',
        full_name: 'Contact Name',
        hauling_plural: 'Hauling Companies',
        hauling_singular: 'Hauling Company',
        hauling_delivery: 'Delivery Hauler',
        license_number: 'License Number',
        metered: 'Metered',
        meteredLevel: 'Metered Amount',
        monthlyReports: 'Monthly Reports',
        processor_plural: 'Processors',
        processor_singular: 'Processor',
        producer_weight: 'Producer Weight',
        routeNumber: 'Route Number',
        routeSession: 'Route Session',
        tank: 'Tank',
        trailer: 'Trailer',
        volume: 'Volume',
    },
    navigation: {},
    lab: {
        scc: 'scc',
        temperature: 'Freezing Point',
        sample_date: 'Date Sampled',
    },
    other: {},
};

export default localization;
